import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { setupUploadProgressReporter } from '@/utils/uploadProgressReporter'
import Vue3Toastify from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import '@/components/Arquivos/study-shell.scss';

// Desabilitar console.log e debug em produção, mantendo apenas console.error
const disableConsoleLogs = process.env.NODE_ENV === 'production' || process.env.VUE_APP_DISABLE_CONSOLE === 'true';

if (disableConsoleLogs) {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  console.warn = () => {};
  // console.error é mantido para erros críticos
}

import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

const vuetify = createVuetify({
    components,
    directives,
})

let aosInstance = null;
let aosLoaded = false;

const ensureAOSForDashboard = async () => {
  if (!aosLoaded) {
    const [{ default: AOS }] = await Promise.all([
      import(/* webpackChunkName: "aos" */ 'aos'),
      import('aos/dist/aos.css')
    ]);
    aosInstance = AOS;
    aosInstance.init();
    aosLoaded = true;
    return;
  }

  if (aosInstance && typeof aosInstance.refreshHard === 'function') {
    aosInstance.refreshHard();
  }
};

const app = createApp(App)
app.use(router)
app.use(
    Vue3Toastify,
    {
      autoClose: 3000,
      // ...
    }
  )
setupUploadProgressReporter(store)
app.use(store)
app.use(vuetify)
app.mount('#app')

router.afterEach((to) => {
  if (!to.path.startsWith('/dashboard')) {
    return;
  }

  ensureAOSForDashboard().catch((error) => {
    console.error('Erro ao carregar AOS:', error);
  });
});

if (router.currentRoute.value.path.startsWith('/dashboard')) {
  ensureAOSForDashboard().catch((error) => {
    console.error('Erro ao carregar AOS:', error);
  });
}
